
import apiSlice from '@/store/api/apiSlice';
import { ApiResponse, ContentCategory, PaginatedResponse } from '@/types';

type CategoryApiResponse =
  | ContentCategory[]
  | ApiResponse<ContentCategory[]>
  | PaginatedResponse<ContentCategory>;

export interface CreateContentCategoryRequest {
  title: string;
  description: string;
  benefits?: string;
  isLocked: boolean;
}

export const categoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContentCategories: builder.query<ContentCategory[], boolean>({
      query: (isLocked) => ({
        url: '/content-categories/',
        method: 'GET',
        params: { isLocked },
      }),
      transformResponse: (response: CategoryApiResponse) => {
        if (Array.isArray(response)) {
          return response;
        }

        return Array.isArray(response.data) ? response.data : [];
      },
      providesTags: ['ContentCategory'],
    }),
    createContentCategory: builder.mutation<ContentCategory, CreateContentCategoryRequest>({
      query: (category) => ({
        url: '/content-categories/',
        method: 'POST',
        body: category,
      }),
      invalidatesTags: ['ContentCategory'],
    }),
    updateContentCategory: builder.mutation<
      ContentCategory,
      Partial<ContentCategory> & { id: number }
    >({
      query: (category) => ({
        url: `/content-categories/${category.id}`,
        method: 'PATCH',
        body: category,
      }),
      invalidatesTags: ['ContentCategory'],
    }),
  }),
  overrideExisting: false,
});
export const {
  useCreateContentCategoryMutation,
  useGetContentCategoriesQuery,
  useUpdateContentCategoryMutation,
} = categoryApi;
